import { BaseProps, Dialog, DialogBody, DialogTitle } from '@/components/base/dialog'
import { Form as NewForm } from './new_form'
import { PackageAssetTypeAttributes } from '@/types'

interface Props extends BaseProps {
  defaultValues: Partial<PackageAssetTypeAttributes>
}

export const NewDialog = ({ open, setOpen, defaultValues }: Props) => {
  return (
    <>
      <Dialog open={open} size="5xl" onClose={setOpen}>
        <DialogTitle>Add asset type</DialogTitle>
        <DialogBody>
          <NewForm defaultValues={defaultValues} onSuccess={() => setOpen(false)} />
        </DialogBody>
      </Dialog>
    </>
  )
}
